import { render, staticRenderFns } from "./TitleCard.vue?vue&type=template&id=315536e5&scoped=true"
import script from "./TitleCard.vue?vue&type=script&lang=js"
export * from "./TitleCard.vue?vue&type=script&lang=js"
import style0 from "./TitleCard.vue?vue&type=style&index=0&id=315536e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315536e5",
  null
  
)

export default component.exports